import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FormControl } from '@angular/forms';
import customerJson from "../../../../assets/config/customer.json";
import translateJson from '../../../../translate.json';

/**
 * @author Timothy Biörck
 * @description This component is a radio button tree allowing the user to better see the project hierarchy
 * when choosing a parent project. The FormControl value will be set to the chosen parent's ID.
 */

 /**
 * Project data with nested structure.
 * Each node has a name and an optiona list of children.
 */
  interface ProjectNode {  
    id: string;
    organisationId: string;  
    name: string,
    compProjectId: string,
    compProjectName: string,
    compIndustry: string,
    supplierType: string,
    archived: boolean,
    children?: ProjectNode[];
  }

  const PROJECT_DATA: ProjectNode[] = [];
  
   interface ProjectFlatNode {
    expandable: boolean;
    name: string;
    id: string;   
    supplierType: string; 
    compProjectId: string;
    archived: boolean;
    level: number;
  }

@Component({
    selector: 'project-radio-tree',
    templateUrl: './project.radio.tree.component.html',
    styleUrls: ['./project.radio.tree.component.css']
})
export class ProjectRadioTreeComponent implements OnChanges {
    @ViewChild('tree') tree;  
    @Input() headProject: any;
    //@Input() headSupplierName: string;
    @Input() control: FormControl;
    @Input() currentProjectId: string; // ID of the viewed project (i.e. in edit view)
    @Input() parentId: any; // Used to identify an already selected parent (i.e. in edit view)
    
    // Angular Tree Components
    private _transformer = (node: ProjectNode, level: number) => {
        return {
          expandable: !!node.children && node.children.length > 0,
          name: node.name,      
          supplierType: node.supplierType,  
          compProjectId: node.compProjectId,
          archived: node.archived,  
          level: level,
        };
      };

    treeControl = new FlatTreeControl<ProjectFlatNode>(
        (node) => node.level,
        (node) => node.expandable
    );

    treeFlattener = new MatTreeFlattener(
        this._transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.children
    );

    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    edition: String = customerJson.edition;
    private i18 = translateJson.i18;

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.headProject) {
            this.handleHeadProjectChange(changes.headProject.currentValue)
        }
        if (changes.parentId) {
            this.handleParentIdChange(changes.parentId.currentValue)
        }        
    }

    hasChild = (_: number, node: ProjectFlatNode) => node.expandable;

    private handleHeadProjectChange(currentValue: any): void {        
        this.dataSource.data = currentValue;                
    }

    private handleParentIdChange(currentValue: any): void {
        if (!this.parentId) {
            this.parentId = currentValue;
        }
    }

    ngAfterViewInit() {
        if(this.dataSource.data != null &&  this.dataSource.data[0].children.length > 0) {
            this.tree.treeControl.expandAll();
        }        
    }
}
